import { render, staticRenderFns } from "./AiReasonBnr.vue?vue&type=template&id=63925674&scoped=true"
import script from "./AiReasonBnr.vue?vue&type=script&lang=js"
export * from "./AiReasonBnr.vue?vue&type=script&lang=js"
import style0 from "./AiReasonBnr.vue?vue&type=style&index=0&id=63925674&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63925674",
  null
  
)

export default component.exports